import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const newsServiceApi = createApi({
  reducerPath: 'newsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetNews: builder.query<any, any>({
      query: ({ page, perPage, language = CURRENT_LANGUAGE, categoryId = null, showMain = false }) =>{
        // console.log('GetNews:', page, perPage, language, categoryId);
        return `notice/?locale=${language}${categoryId ? `&categories=${categoryId}`:''}&pageNumber=${page}&elementsPerPage=${perPage}&showMain=${showMain}`;
      }
    }),
    GetNewById: builder.query<any, any>({
      query: ({ newId, language = CURRENT_LANGUAGE }) => `notice/${newId}?locale=${language}`,
    }),
    GetNewsCategories: builder.query<any, any>({
      query: ({language = CURRENT_LANGUAGE}) => `notice/category?locale=${language}`,
    }),
    GetSearchNewBytxt: builder.query<any, any>({
      query: ({ txt, language = CURRENT_LANGUAGE }) => `notice/search??locale=${language}&txt=${txt}`,
    }),
  }),
});

export const {
  useLazyGetNewsQuery,
  useLazyGetNewByIdQuery,
  useLazyGetNewsCategoriesQuery,
  useLazyGetSearchNewBytxtQuery,
} = newsServiceApi;
